import _ from 'lodash';
import { PlayerData, PlayerStatType } from '../../../data/struct';
import { ResourceHelper } from '../helper';
import { DataActionType } from './DataActionType';

export interface DataAction_Unlock_SelfDev {
	actionType: DataActionType.Unlock_SelfDev,
	statType: PlayerStatType,
	step: number,
	consumption: number,
}
export namespace DataAction_Unlock_SelfDev {
	export function Do(data: PlayerData, action: DataAction_Unlock_SelfDev): PlayerData {
		const clone_resource = _.cloneDeep(data.resource);
		const resourceHelper = new ResourceHelper(clone_resource, data.upgrade);
		const isValid = resourceHelper.decMoney(action.consumption);

		if (!isValid) { return data; }

		return {
			...data,
			resource: resourceHelper.get(),
			selfDevelopment: [...data.selfDevelopment, {
				key: action.statType,
				step: action.step,
			}],
		};
	}
}
